import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { PermissionsManagerService } from './permissions-manager.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[hasPermission]',
  standalone: false,
})
export class PermissionsManagerDirective implements OnInit, OnDestroy {
  private permissions: string | string[] = [];
  private subscription: Subscription | null = null;

  constructor(
    private readonly permissionsManager: PermissionsManagerService,
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
  ) {}

  @Input() set hasPermission(permissions: string | string[]) {
    this.permissions = permissions;
    this.updateView();
  }

  ngOnInit(): void {
    this.subscription = this.permissionsManager.permissionsChanged$.subscribe(
      () => {
        this.updateView();
      },
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateView(): void {
    const hasPermission = Array.isArray(this.permissions)
      ? this.permissionsManager.hasAny(this.permissions)
      : this.permissionsManager.has(this.permissions);

    if (hasPermission) {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.clear();
    }
  }
}
